import { PendingReauthNotification } from 'components/notifications/PendingReauthNotification';

export const RTANotificationTypes = {
    PENDREAUTH: 'PENDREAUTH',
};

export const NotificationComponentMap = {
    [RTANotificationTypes.PENDREAUTH]: PendingReauthNotification,
};
